const getDiffInDays = ({ type = "ago", dateValue }) => {
    let currentDate = Date.now();
    if(typeof dateValue === 'string'){
        dateValue = parseInt(dateValue);
    }
    let diff = type === 'ago' ? currentDate - dateValue : dateValue - currentDate;
    let diffInDays = Math.ceil(((((diff) / 1000) / 60) / 60) / 24);
    return diffInDays;
}
const getFirstValueFromArray = (value) => {
    if(!value){
        return '';
    }
    if(value && Array.isArray(value)) {
        if(value.length){
            return value[0]
        }
        return '';
    }
    return value;
}
const DateOperators = {
     is: {
        id: 'is',
        matcher: (value, matchValue) => {
            value = getFirstValueFromArray(value)
            return value === parseFloat(matchValue);
        }
    },
    is_not: {
        id: 'is_not',
        matcher: (value, matchValue) => {
            value = getFirstValueFromArray(value)
            if(!value) return true;
            return value < parseFloat(matchValue);
        }
    },
    exactly: {
        id: 'exactly',
        matcher: (value, matchValue) => {
            value = getFirstValueFromArray(value)
            if(!value) return false;
            const diffInDays = getDiffInDays({ type: "ago", dateValue: value })
            return diffInDays == parseInt(matchValue);
        }
    },
    less_than: {
        id: 'less_than',
        matcher: (value, matchValue) => {
            value = getFirstValueFromArray(value)
            if(!value){
                return false;
            }
            const diffInDays = getDiffInDays({ type: "ago", dateValue: value })
            return diffInDays < parseInt(matchValue);
        }
    },
    more_than: {
        id: 'more_than',
        matcher: (value, matchValue) => {
            value = getFirstValueFromArray(value)
            if(!value){
                return false;
            }
            const diffInDays = getDiffInDays({ type: "ago", dateValue: value })
            return diffInDays > parseInt(matchValue);
        }
    },
    between: {
        id: 'between',
        matcher: (value, matchValue) => {
            value = getFirstValueFromArray(value)
            if(!value){
                return false;
            }
            const splitPart = matchValue.split(',');
            const first = parseInt(splitPart[0].trim());
            const second = parseInt(splitPart[1].trim());
            const diffInDays = getDiffInDays({ type: "ago", dateValue: value })
            return diffInDays > first && diffInDays < second;
        }
    },

    exactly_in_future: {
        id: 'exactly_in_future',
        matcher: (value, matchValue) => {
            value = getFirstValueFromArray(value)
            if(!value) return false;
            const diffInDays = getDiffInDays({ type: "in_future", dateValue: value })
            return diffInDays == parseInt(matchValue);
        }
    },
    less_than_in_future: {
        id: 'less_than_in_future',
        matcher: (value, matchValue) => {
            value = getFirstValueFromArray(value)
            if(!value) return false;
            const diffInDays = getDiffInDays({ type: "in_future", dateValue: value })
            return diffInDays < parseInt(matchValue);
        }
    },
    more_than_in_future: {
        id: 'more_than_in_future',
        matcher: (value, matchValue) => {
            value = getFirstValueFromArray(value)
            if(!value) return false;
            const diffInDays = getDiffInDays({ type: "in_future", dateValue: value })
            return diffInDays > parseInt(matchValue);
        }
    },
    between_in_future: {
        id: 'between_in_future',
        matcher: (value, matchValue) => {
            value = getFirstValueFromArray(value)
            if(!value) return false;
            const splitPart = matchValue.split(',');
            const first = parseInt(splitPart[0].trim());
            const second = parseInt(splitPart[1].trim());
            const diffInDays = getDiffInDays({ type: "in_future", dateValue: value })
            return diffInDays > first && diffInDays < second;
        }
    },
    is_unknown: {
        id: 'is_unknown',
        matcher: (value, _) => {
            value = getFirstValueFromArray(value)
            if(!value) return true;
            return value === undefined || value === null || value === ''
        }
    },
    has_any_value: {
        id: 'has_any_value',
        matcher: (value, _) => {
            value = getFirstValueFromArray(value)
            return !(value === undefined || value === null || value === '')
        }
    },
    on: {
        id: 'on',
        matcher: (value, matchValue) => {
            value = getFirstValueFromArray(value)
            if(!value) return false;
            return parseInt(value) === parseInt(matchValue);
        }
    },
    after: {
        id: 'after',
        matcher: (value, matchValue) => {
            value = getFirstValueFromArray(value)
            if(!value) return false;
            return parseInt(value) > parseInt(matchValue);
        }
    },
    before: {
        id: 'before',
        matcher: (value, matchValue) => {
            value = getFirstValueFromArray(value)
            if(!value) return false;
            return parseInt(value) < parseInt(matchValue);
        }
    },
};
module.exports.DateOperators = DateOperators;